// Central defaults for Avatar Chat video settings
// Keep within plugin folder per project guidelines

export const VIDEO_CHAT_DEFAULTS = {
  output: {
    width: 640,
    height: 360,
    fps: 24
  },
  layerVisibility: {
    background: true,
    camera: true,
    avatarImage: true,
    avatarFace: true,
    avatarEyes: true,
    avatarHair: true
  },
  // Camera background removal (segmentation)
  useSegmentation: true,
  segmentationMaskScale: 0,
  segmentationMaskThreshold: 0,
  segmentationInvertMask: null,
  segmentationDebugOverlay: false,
  meshWorkerEnabled: true,
  // Use full head texture as warp source and mask to face for higher-quality warps
  highQualityWarp: false,
  // Rendering/overlay behavior (engine-specific)
  overlayMode: 'auto',
  // Expression tuning profile
  expressionPresetId: 'expressive',
  expressionStrength: 2.46,
  faceFitStrength: 0.72,
  mouthBoost: 1.2,
  mouthSmoothing: 0.42,
  browStrength: 1.56,
  browSmoothing: 0.34,
  cheekStrength: 3.58,
  cheekSmoothing: 0.32,
  // Eye settings
  eye: {
    irisColor: '',
    irisBorderColor: '#22303A',
    pupilColor: '#0A0E16',
    scleraCenter: '#F6F9FC',
    scleraEdge: '#000000',
    // Optional text labels consumed by some UIs
    irisText: '',
    irisBorderText: '',
    pupilText: '',
    scleraCenterText: '',
    scleraEdgeText: ''
  },
  irisStyle: 'vector',
  // Current background (id of local/uploaded, or builtin id)
  background: {
    id: '',
    src: null
  }
}
